module.exports = __webpack_public_path__ + "img/colaborador-mariana-emilio.c08ea8ae.jpeg";